import { KenticoRulesCreator } from '../builders/KenticoRulesCreator';
import { KenticoRulesHelper } from '../KenticoRulesHelper';
import { getResourceString } from '../resource-strings';

export class KenticoFormControlHelpers {

    static getContributieBlock(fieldName, category, membershipAmountResourcestring, additionalTextResourcestring, visibilityCondition) : any {
      const additionalText = getResourceString(additionalTextResourcestring);
      return {
        "isContributieTabelField": true,
        "name": "contributietabel-" + fieldName,
        "id": "contributietabel-id-" + fieldName,
        "label": getResourceString(membershipAmountResourcestring),
        "type": "custom",
        "customType": "contributie",
        "validation": {
          "required": {
            "error": getResourceString("Form.Error.RequiredField")
          }     
        },    
        "section": 'category-' + category,
        "sectionCssClass": "contributietabel",
        "defaultValue": "",
        "clearFields": [],
        "lidVoordelenRichtText": "<p>&nbsp;</p>\r\n",
        "lidVoordelenBeforeText": "&nbsp;",
        "lidVoordelenTitle": "&nbsp;",
        "lidWordenButtonTitle": "",
        "periodText": "per maand",
        "toonLidVoordelen": "False",
        "toonLidWordenButton": "False",
        "title": "Dit wordt jouw contributie",
        "afterText": "",
        "additionalText": (additionalText === "&amp;nbsp;" || additionalText === "-") ? "" : additionalText,
        "visibilityCondition": [
          {
            kenticoVisibilityFunction: KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
              `{%${visibilityCondition}|(user)React|(hash)1234%}`
            ),
            type: 'kentico'
          }
        ],
      };
    }

    static getContributieTabel(field, category, formFieldOverrides) : any {
      let controls = [
        {
          "isContributieTabelField": true,
          "name": "Situatie",
          "id": "contributietabel-Situatie",
          "label": "Wat is je situatie?",
          "type": "radio-styled",
          "validation": {
            "required": {
              "error": getResourceString("Form.Error.RequiredField")
            }     
          },    
          "section": 'category-' + category,
          "sectionCssClass": "contributietabel",
          "options": ["Ik studeer", "Ik werk", "Ik werk (tijdelijk) niet"],
          "valueoptions": ["student", "werkend", "werkt_niet"],
          "defaultValue": "",
          "clearFields": [
            "StudieVorm", "WerkVorm", "Watisjebrutomaandinkomen"
          ] 
        },
        {
          "isContributieTabelField": true,
          "name": "StudieVorm",
          "id": "contributietabel-StudieVorm",
          "label": "In welke vorm studeer je?",
          "type": "radio-styled",
          "validation": {
            "required": {
              "error": getResourceString("Form.Error.RequiredField")
            }     
          },    
          "section": 'category-' + category,
          "sectionCssClass": "contributietabel",
          "options": ["Voltijd/BOL", "Deeltijd/BBL"],
          "valueoptions": ["voltijd", "deeltijd"],
          "defaultValue": "",
          "clearFields": [
            "Watisjebrutomaandinkomen"           
          ],
          "visibilityCondition": [
            {
              kenticoVisibilityFunction: KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
                `{%Fields["Situatie"].Value === "student"|(user)React|(hash)1234%}`
              ),
              type: 'kentico'
            }
          ],
        },
        {
          "isContributieTabelField": true,
          "name": "WerkVorm",
          "id": "contributietabel-WerkVorm",
          "label": "Welke vorm?",
          "type": "radio-styled",
          "validation": {
            "required": {
              "error": getResourceString("Form.Error.RequiredField")
            }     
          },    
          "section": 'category-' + category,
          "sectionCssClass": "contributietabel",
          "options": ["In loondienst", "Als ZZP’er", "Als uitzendkracht"],
          "valueoptions": ["loondienst", "zzp", "uitzendkracht"],
          "defaultValue": "",
          "clearFields": [
            "Watisjebrutomaandinkomen"          
          ],
          "visibilityCondition": [
            {
              kenticoVisibilityFunction: KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
                `{%Fields["Situatie"].Value === "werkend"|(user)React|(hash)1234%}`
              ),
              type: 'kentico'
            }
          ],
        },
        {
          "isContributieTabelField": true,
          "name": "Watisjebrutomaandinkomen",
          "id": "contributietabel-Watisjebrutomaandinkomen",
          "label": "Wat is je bruto maandinkomen?",
          "type": "radio-styled",
          "validation": {
            "required": {
              "error": getResourceString("Form.Error.RequiredField")
            }     
          },    
          "section": 'category-' + category,
          "sectionCssClass": "contributietabel",
          "options": [
            getResourceString("LidWorden.ContributieBlock.WerkInkomenLaag"), 
            getResourceString("LidWorden.ContributieBlock.WerkInkomenMidden"), 
            getResourceString("LidWorden.ContributieBlock.WerkInkomenHoog")
          ],
          "valueoptions": ["laag", "midden", "hoog"],
          "defaultValue": "",
          "clearFields": [
          ],
          "visibilityCondition": [
            {
              kenticoVisibilityFunction: KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
                `{%Fields["Situatie"].Value !== "" && Fields["StudieVorm"] !== "voltijd" && Fields["WerkVorm"] !== "zzp" && 
                  Fields["Situatie"].Value !== "werkt_niet" && 
                  (Fields["StudieVorm"].Value === "deeltijd" || 
                    Fields["WerkVorm"].Value === "loondienst" || 
                    Fields["WerkVorm"].Value === "uitzendkracht")|(user)React|(hash)1234%}`
              ),
              type: 'kentico'
            }
          ],
        },
        this.getContributieBlock("ContributieBlock-studentvoltijd", category,
          "LidWorden.ContributieBlockStudentVoltijd.Amount",  
          "LidWorden.ContributieBlockStudentVoltijd.AdditionalText", 
          `Fields["StudieVorm"].Value === "voltijd"`),
        this.getContributieBlock("ContributieBlock-studentdeeltijdlaag", category,
          "LidWorden.ContributieBlockStudentDeeltijdLaag.Amount", 
          "LidWorden.ContributieBlockStudentDeeltijdLaag.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "laag" && Fields["StudieVorm"].Value === "deeltijd"`),
        this.getContributieBlock("ContributieBlock-studentdeeltijdmidden", category,
          "LidWorden.ContributieBlockStudentDeeltijdMidden.Amount", 
          "LidWorden.ContributieBlockStudentDeeltijdMidden.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "midden" && Fields["StudieVorm"].Value === "deeltijd"`),
        this.getContributieBlock("ContributieBlock-studentdeeltijdhoog", category,
          "LidWorden.ContributieBlockStudentDeeltijdHoog.Amount", 
          "LidWorden.ContributieBlockStudentDeeltijdHoog.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "hoog" && Fields["StudieVorm"].Value === "deeltijd"`),

        this.getContributieBlock("ContributieBlock-werkt_niet", category,
          "LidWorden.ContributieBlockWerktTijdelijkNiet.Amount", 
          "LidWorden.ContributieBlockWerktTijdelijkNiet.AdditionalText", 
          `Fields["Situatie"].Value === "werkt_niet"`),

        this.getContributieBlock("ContributieBlock-zzp", category,
          "LidWorden.ContributieBlockZZP.Amount", 
          "LidWorden.ContributieBlockZZP.AdditionalText", 
          `Fields["Situatie"].Value === "werkend" && Fields["WerkVorm"].Value === "zzp"`),

        this.getContributieBlock("ContributieBlock-werkendlaag", category,
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtLaag.Amount", 
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtLaag.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "laag" && Fields["Situatie"].Value === "werkend" && (Fields["WerkVorm"].Value === "loondienst" || Fields["WerkVorm"].Value === "uitzendkracht")`),
        this.getContributieBlock("ContributieBlock-werkendmidden", category,
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtMidden.Amount", 
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtMidden.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "midden" && Fields["Situatie"].Value === "werkend" && (Fields["WerkVorm"].Value === "loondienst" || Fields["WerkVorm"].Value === "uitzendkracht")`),
        this.getContributieBlock("ContributieBlock-werkendhoog", category,
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtHoog.Amount", 
          "LidWorden.ContributieBlockWerkendLoondienstUitzendkrachtHoog.AdditionalText", 
          `Fields["Watisjebrutomaandinkomen"].Value === "hoog" && Fields["Situatie"].Value === "werkend" && (Fields["WerkVorm"].Value === "loondienst" || Fields["WerkVorm"].Value === "uitzendkracht")`),  
      ];
      controls.map((control : any) => {

        if (control.visibilityCondition === undefined) {
          control.visibilityCondition = [];
        }
        
        KenticoRulesCreator.handleVisiblity(field, KenticoRulesCreator.mergeFormDefinition(control , formFieldOverrides));
      });        

      return controls;
    }

    static getAddressControls(field, category, formFieldOverrides) : any {

        let prefixFieldName = "";
        if (field.settings && field.settings.PrefixVoorAdresblokVelden) {
          prefixFieldName = field.settings.PrefixVoorAdresblokVelden;
        }
        let IkWoonInLabel = "";
        if (field.settings && field.settings.IkWoonInLabel) {
          IkWoonInLabel = field.settings.IkWoonInLabel;
        }
        let WoonplaatsLabel = "";
        if (field.settings && field.settings.WoonplaatsLabel) {
          WoonplaatsLabel = field.settings.WoonplaatsLabel;
        }

        let isRequired = true;

        const applyRequiredFieldSetting =  (field.settings?.ApplyRequiredFieldSetting ?? "").toLowerCase();
        if (applyRequiredFieldSetting === "true") {
          isRequired = field['@allowempty'] !== 'true';
        }
        
        const macroFunctionFromKenticoRule = KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
          `{%Fields["${prefixFieldName}NederlandAnderLand"].Value === "*"|(user)React|(hash)1234%}`
        );

        const macroFunctionIsNederlandFromKenticoRule = KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
          `{%Fields["${prefixFieldName}NederlandAnderLand"].Value === "NL"|(user)React|(hash)1234%}`
        );        
        
        const getRequiredValidation = (errorMessage) => {
          if (isRequired) {
            return {
                "required": {
                  "error": getResourceString(errorMessage)
                }              
            };
          }
          return {};
        };

        let controls = [
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "NederlandAnderLand",
            "id": prefixFieldName + "adresblok-NederlandAnderLand",
            "label": IkWoonInLabel || getResourceString("Form.NederlandAnderLand.Label"),
            "type": "radio",
            "validation": {
              ...getRequiredValidation("Form.NederlandAnderLand.RequiredError"),       
            },    
            "section": prefixFieldName + "adresblok-nederlandanderland",
            "sectionCssClass": "adresblok-nederlandanderland",
            "options": [getResourceString("Form.NederlandAnderLand.Option.Netherlands"), getResourceString("Form.NederlandAnderLand.Option.ForeignCountry")],
            "valueoptions": ["NL", "*"],
            "triggerFieldWithCondition": {
              "field": prefixFieldName + "Postcode",
              "value": "NL",
              "datasource": prefixFieldName + "postcode"
            },
            "defaultValue": "NL",
            "clearFields": [
              prefixFieldName + "Land", 
              prefixFieldName + "Postcode", 
              prefixFieldName + "Huisnummer", 
              prefixFieldName + "Toevoeging", 
              prefixFieldName + "Straat", 
              prefixFieldName + "Woonplaats"
            ] 
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Land",
            "id": prefixFieldName + "adresblok-Land",
            "label": getResourceString("Form.Land.Label"),
            "type": "dropdown",
            "datasource": prefixFieldName + "countries",
            "section": prefixFieldName + "adresblok-land",
            "sectionCssClass": "adresblok-land",
            "placeholder": getResourceString("Form.Land.SelectCountry"),            
            "validation": {
              ...getRequiredValidation("Form.Land.RequiredError")
            },
            "visibilityCondition": [
              {
                kenticoVisibilityFunction: macroFunctionFromKenticoRule,
                type: 'kentico'
              }
            ],
            "includeDefaultEmptyOption": false,
            "defaultEmptyOption": "",
            "optionField": "landNaamField",
            "valueField": "landCodeField"
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Postcode",
            "id": prefixFieldName + "adresblok-Postcode",
            "label": getResourceString("Form.Postalcode.Label"),
            "type": "maskedtext",            
            "mask": "9999aa",
            "alwaysUppercase": true,
            "validation": {
              "dataType": {
                "kind": "postcodenl",
                "error": getResourceString("Form.Postalcode.Error") 
              },
              ...getRequiredValidation("Form.Postalcode.RequiredError")                  
            },
            "datasoureRequiresAllFieldsFilled": true, 
            "datasource": prefixFieldName + "postcode",
            "datasourceConditions" : {
              kenticoMacroFunction: macroFunctionIsNederlandFromKenticoRule,
              type: 'kentico'
            },
            "enableMaskConditions" : {
              kenticoMacroFunction: macroFunctionIsNederlandFromKenticoRule,
              type: 'kentico'
            },
            "section": prefixFieldName + "adresblok", //"category-" + category,
            "sectionCssClass": "adresblok", //"category-" + category,
            "cssClass": "mijnfnv__postcode",
            "alwaysShowSummaryField": true,
            "autoCompleteToken": "postal-code"
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Huisnummer",
            "id": prefixFieldName + "adresblok-Huisnummer",
            "label": getResourceString("Form.Housenumber.Label"),
            "type": "text",
            "datasoureRequiresAllFieldsFilled": true,            
            "maskCharsExpression": "^[0-9]+$",
            "maxlength": 250,
            "validation": {
              "dataType": {
                "kind": "number",
                "error": getResourceString("Form.Housenumber.ErrorOnlyNumbers")
              },              
              ...getRequiredValidation("Form.Housenumber.RequiredError"),
              "integer": {
                "error": getResourceString("Form.Housenumber.ErrorOnlyNumbers")
              }
            },
            "datasource": prefixFieldName + "postcode",
            "datasourceConditions" : {
              kenticoMacroFunction: macroFunctionIsNederlandFromKenticoRule,
              type: 'kentico'
            },
            "__datasourceConditions": [
              {
                "fieldName": prefixFieldName + "NederlandAnderLand",
                "value": "NL"
              }
            ],
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__huisnr",
            "alwaysShowSummaryField": true,
            "autoCompleteToken": "address-line2"
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Toevoeging",
            "id": prefixFieldName + "adresblok-Toevoeging",
            "label": getResourceString("Form.HousenumberAddition.Label"),
            "type": "text",
            "maxlength": 15,
            "validation": {},
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__toevoeging",
            "alwaysShowSummaryField": true,
            "autoCompleteToken": "address-line3"
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "PostcodeCheckHint",
            "id": prefixFieldName + "adresblok-PostcodeCheckHint",
            "label": "PostcodeCheckHint",
            "type": "readOnly",
            "maxlength": 15,
            "validation": {},
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__postcodecheckhint",
            "alwaysShowSummaryField": false,
            "readOnly": true,
            "visibleOnError": "false",
            "fieldForErrorCheck": prefixFieldName + "Straat",
            "defaultValue": getResourceString("Form.PostalcodeCheckHint.Text"),
            "visibilityCondition": [
              {
                kenticoVisibilityFunction: macroFunctionIsNederlandFromKenticoRule,
                type: 'kentico'
              }
            ] 
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "PostcodeCheckHintError",
            "id": prefixFieldName + "adresblok-PostcodeCheckHintError",
            "label": "PostcodeCheckHintError",
            "type": "readOnly",
            "maxlength": 15,
            "validation": {},
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__postcodecheckerrorhint",
            "alwaysShowSummaryField": false,
            "readOnly": true,
            "visibleOnError": "true",
            "fieldForErrorCheck": prefixFieldName + "Straat",
            "defaultValue": getResourceString("Form.PostalcodeCheckHint.Error"),
            "visibilityCondition": [
              {
                kenticoVisibilityFunction: macroFunctionIsNederlandFromKenticoRule,
                type: 'kentico'
              }
            ] 
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Straat",
            "id": prefixFieldName + "adresblok-Straat",
            "label": getResourceString("Form.Street.Label"),
            "type": "text",
            "maxlength": 250,
            "validation": {
              ...getRequiredValidation("Form.Street.RequiredError")
            },
            "__disabled": "true",
            "enabledOnError": "true",
            "__enabledConditions" : [
              {
                "fieldName": "NederlandAnderLand",
                "value": "*"
              }
            ],  
            "enabledCondition" : {
              kenticoMacroFunction: macroFunctionFromKenticoRule,
              type: 'kentico'
            },            
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__straat",
            "alwaysShowSummaryField": true,
            "autoCompleteToken": "address-line1"
          },
          {
            "isAdresBlokField": true,
            "prefixVoorAdresblokVelden" : prefixFieldName,
            "name": prefixFieldName + "Woonplaats",
            "id": prefixFieldName + "adresblok-Woonplaats",
            "label": WoonplaatsLabel || getResourceString("Form.City.Label"),
            "type": "text",
            "maxlength": 80,
            "validation": {
              ...getRequiredValidation("Form.City.RequiredError")                           
            },
            "__disabled": "true",
            "enabledOnError": "true",
            "__enabledConditions" : [
              {
                "fieldName": "NederlandAnderLand",
                "value": "*"
              }
            ],
            "enabledCondition" : {
              kenticoMacroFunction: macroFunctionFromKenticoRule,
              type: 'kentico'
            },
            "section": prefixFieldName + "adresblok",
            "sectionCssClass": "adresblok",
            "cssClass": "mijnfnv__woonplaats",
            "alwaysShowSummaryField": true,
            "autoCompleteToken": "address-level2"
          }
        ];

        controls.map((control : any) => {

          if (control.visibilityCondition === undefined) {
            control.visibilityCondition = [];
          }
          
          KenticoRulesCreator.handleVisiblity(field, KenticoRulesCreator.mergeFormDefinition(control , formFieldOverrides));
        });        

        return controls;
    }

    static getAddressControlsReadOnly(field, category, formFieldOverrides) : any {
      const macroFunctionFromKenticoRule = KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
        '{%false%}'
      );
      let controls = [
        {
          "isAdresBlokField": true,
          "name": "Adres",
          "label": field.properties.fieldcaption || getResourceString("Form.Address.Label"),
          "type": "readOnly",
          "maxlength": 100,
          "validation": {},
          "format": "{Straat} {Huisnummer} {Toevoeging}<br />{Postcode} {Woonplaats}",
          "disabled": "true",
          "section": "category-" + category,
          "alwaysShowSummaryField": true,
        },
        {
          "isAdresBlokField": true,
          "name": "NederlandAnderLand",
          "id": "adresblok-NederlandAnderLand",
          "label": getResourceString("Form.NederlandAnderLand.Label"),
          "type": "radio",
          "validation": {},
          "disabled": "true",
          "section": "category-" + category,
          "options": [getResourceString("Form.NederlandAnderLand.Option.Netherlands"), getResourceString("Form.NederlandAnderLand.Option.ForeignCountry")],
          "valueoptions": ["NL", "*"],
          "visibilityCondition" : [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]   
        },
        {
          "isAdresBlokField": true,
          "name": "Land",
          "id": "adresblok-Land",
          "label": getResourceString("Form.Country.Label"),
          "type": "readOnly",
          "datasource": "countries",
          "validation": {},
          "section": "category-" + category,
          "placeholder": getResourceString("Form.Land.SelectCountry"),
          "optionField": "Label",
          "valueField": "Id",
          "disabled": "true",
          "visibilityCondition": [
            {
              "fieldName": "NederlandAnderLand",
              "value": "*"
            }
          ] 
        },
        {
          "isAdresBlokField": true,
          "name": "Straat",
          "id": "adresblok-Straat",
          "label": "",
          "type": "readOnly",
          "validation": {},
          "section": "category-" + category,
          "disabled": "true",
          "visibilityCondition": [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]
        },
        {
          "isAdresBlokField": true,
          "name": "Huisnummer",
          "id": "adresblok-Huisnummer",
          "label": "",
          "type": "readOnly",
          "validation": {},
          "section": "category-" + category,
          "disabled": "true",
          "visibilityCondition": [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]
        },
        {
          "isAdresBlokField": true,
          "name": "Toevoeging",
          "id": "adresblok-Toevoeging",
          "label": "",
          "type": "readOnly",
          "validation": {},
          "section": "category-" + category,
          "disabled": "true",
          "visibilityCondition": [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]
        },
        {
          "isAdresBlokField": true,
          "name": "Postcode",
          "id": "adresblok-Postcode",
          "label": "",
          "type": "readOnly",
          "validation": {},
          "section": "category-" + category,
          "disabled": "true",
          "visibilityCondition": [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]
        },
        {
          "isAdresBlokField": true,
          "name": "Woonplaats",
          "id": "adresblok-Woonplaats",
          "label": "",
          "type": "readOnly",
          "validation": {},
          "section": "category-" + category,
          "disabled": "true",
          "visibilityCondition": [{
            kenticoVisibilityFunction : macroFunctionFromKenticoRule,
            type: 'kentico'
          }]
        }
      ];

      // 
      controls.map((control : any) => {
        
        if (control.visibilityCondition === undefined) {
          control.visibilityCondition = [];
        }

        KenticoRulesCreator.handleVisiblity(field, KenticoRulesCreator.mergeFormDefinition(control , formFieldOverrides));
      });

      return controls;
  }
  static getRegexForNameFields = () => {
    return "^[a-zA-ZÀ-ž ,.'-]+$";
  }
} 